document.querySelectorAll('header-menu details').forEach(details => {
  details.addEventListener('mouseover', () => {
    details.setAttribute('open', true);
  });
  details.addEventListener('mouseleave', () => {
    details.removeAttribute('open');
  });
});





$(document).ready(function() {
  $('.predictive-search__loading-state').removeClass('hidden');
});



// document.addEventListener('click', function(e) {


//   if (e.target.classList.contains('addon-add')) {
//     const btn = e.target;
//     const variantId = btn.getAttribute('data-variant');
//     const parentKey = btn.getAttribute('data-parent-key');
//     const parentTitle = btn.getAttribute('data-parent-title');

//     btn.innerText = 'Adding...';
//     btn.disabled = true;

//     fetch(window.Shopify.routes.root + 'cart/add.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({
//         items: [{
//           id: variantId,
//           quantity: 1,
//           properties: {
//             '_is_addon': 'true',
//             '_parent_key': parentKey,
//             '_parent_title': parentTitle
//           }
//         }]
//       })
//     })
//     .then(r => r.json())
//     .then(() => refreshCartDrawer())
//     .catch(error => {
//       console.error('Error adding addon:', error);
//       btn.innerText = 'Add';
//       btn.disabled = false;
//     });
//   }

//   if (e.target.classList.contains('addon-remove')) {
//     const btn = e.target;
//     const lineKey = btn.getAttribute('data-key');

//     btn.innerText = 'Removing...';
//     btn.disabled = true;

//     fetch(window.Shopify.routes.root + 'cart/change.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ id: lineKey, quantity: 0 })
//     })
//     .then(r => r.json())
//     .then(() => refreshCartDrawer())
//     .catch(error => {
//       console.error('Error removing addon:', error);
//       btn.innerText = 'Remove';
//       btn.disabled = false;
//     });
//   }

//   const removeBtn = e.target.closest('[data-remove-parent]');
//   if (removeBtn) {
//     e.preventDefault();
//     e.stopImmediatePropagation(); 

//     const parentKey = removeBtn.getAttribute('data-parent-key');
//     const parentTitle = removeBtn.getAttribute('data-parent-title');

//     removeItemWithAddons(parentKey, parentTitle);
//   }

// }, true);


// function removeItemWithAddons(parentKey, parentTitle) {
//   fetch(window.Shopify.routes.root + 'cart.js')
//     .then(r => r.json())
//     .then(cart => {

//       const updates = {};
//       updates[parentKey] = 0;

//       cart.items
//         .filter(item =>
//           item.properties._is_addon === 'true' &&
//           item.properties._parent_title === parentTitle
//         )
//         .forEach(addon => {
//           updates[addon.key] = 0;
//         });

//       return fetch(window.Shopify.routes.root + 'cart/update.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ updates })
//       });
//     })
//     .then(r => r.json())
//     .then(() => refreshCartDrawer())
//     .catch(error => console.error('Error removing parent with addons:', error));
// }


// function refreshCartDrawer() {
//   fetch(window.location.pathname + '?section_id=cart-drawer')
//     .then(r => r.text())
//     .then(responseText => {
//       const html = new DOMParser().parseFromString(responseText, 'text/html');
//       const newContent = html.querySelector('.drawer__inner');
//       const currentContent = document.querySelector('.drawer__inner');

//       if (newContent && currentContent) {
//         currentContent.innerHTML = newContent.innerHTML;
//       }
//     })
//     .catch(error => console.error('Error refreshing cart:', error));
// }


document.addEventListener('click', function (e) {

  // Add Addon
  const addBtn = e.target.closest('.addon-add');

  if (addBtn) {

    const variantId = addBtn.dataset.variant;
    const parentKey = addBtn.dataset.parentKey;
    const parentTitle = addBtn.dataset.parentTitle;

    addBtn.innerText = 'Adding...';
    addBtn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1,
          properties: {
            '_is_addon': 'true',
            '_parent_key': parentKey,
            '_parent_title': parentTitle
          }
        }]
      })
    })
      .then(res => res.json())
      .then(() => {
        refreshDawnCart();
      })
      .catch(error => {
        console.error('Addon add error:', error);
        addBtn.innerText = 'Add';
        addBtn.disabled = false;
      });

    return;
  }

  // Remove Addon
  const addonRemoveBtn = e.target.closest('.addon-remove');

  if (addonRemoveBtn) {

    const lineKey = addonRemoveBtn.dataset.key;

    addonRemoveBtn.innerText = 'Removing...';
    addonRemoveBtn.disabled = true;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: lineKey,
        quantity: 0
      })
    })
      .then(res => res.json())
      .then(() => {
        refreshDawnCart();
      })
      .catch(error => {
        console.error('Addon remove error:', error);
        addonRemoveBtn.innerText = 'Remove';
        addonRemoveBtn.disabled = false;
      });

    return;
  }

  // Remove Parent + Addons
  const removeBtn = e.target.closest('[data-remove-parent]');

  if (removeBtn) {

    e.preventDefault();
    e.stopPropagation();

    const parentKey = removeBtn.dataset.parentKey;

    removeItemWithAddons(parentKey);

    return;
  }

});

function removeItemWithAddons(parentKey) {

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {

      const requests = [];

      // Remove Parent
      requests.push(
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: parentKey,
            quantity: 0
          })
        })
      );

      // Remove Linked Addons
      cart.items
        .filter(item =>
          item.properties?._is_addon === 'true' &&
          item.properties?._parent_key === parentKey
        )
        .forEach(item => {

          requests.push(
            fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                id: item.key,
                quantity: 0
              })
            })
          );

        });

      return Promise.all(requests);

    })
    .then(() => {
      refreshDawnCart();
      // document.querySelector('cart-drawer').classList.add('is-empty')
    })
    .catch(error => {
      console.error('Parent remove error:', error);
    });
}

function refreshDawnCart() {

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {

      fetch('/?sections=cart-drawer,cart-icon-bubble')
        .then(response => response.json())
        .then(sections => {

          const cartDrawer = document.querySelector('cart-drawer');

          if (!cartDrawer) return;

          cartDrawer.renderContents({
            id: Date.now(),
            sections: {
              'cart-drawer': sections['cart-drawer'],
              'cart-icon-bubble': sections['cart-icon-bubble']
            }
          });

          if (cart.item_count === 0) {
            cartDrawer.classList.add('is-empty');
          } else {
            cartDrawer.classList.remove('is-empty');
          }

        });

    })
    .catch(error => {
      console.error('Cart refresh error:', error);
    });
}






$(document).on('click', '.ct_filter_btn', function() {
    $('.disclosure-has-popup.mobile-facets__disclosure > .mobile-facets__open-wrapper').click();
});


$(document).on('mouseenter', '.mega-menu_tab_item', function(){
  var index = $(this).index();
  $('.mega-menu_tab_item').removeClass('active');
  $(this).addClass('active');
  $('.mega-menu_tab_content_item').removeClass('active');
  $('.mega-menu_tab_content_item').eq(index).addClass('active');
});

$(document).on('mouseenter', '.mega-menu_sidebar_item', function(){
  var index = $(this).index();
  $(this).parents('.mega-menu_tab_content_item').find('.mega-menu_sidebar_item').removeClass('active');
  $(this).addClass('active');
  $(this).parents('.mega-menu_tab_content_item').find('.mega-menu_products_wrap').removeClass('active');
  $(this).parents('.mega-menu_tab_content_item').find('.mega-menu_products_wrap').eq(index).addClass('active');
});


$(document).on('click', '.order-summary-title', function(){
  // $('.order-summary-title').removeClass('active');
  $(this).toggleClass('active');
  $('.order-summary_drop').slideToggle();
});


//shopify dawn theme product media hover script start
if ($('.product__media-item')) {
document.querySelectorAll('.product__media-item').forEach((media) => {
  media.addEventListener('mouseenter', () => {
    media.querySelector('.image-magnify-hover').click();
  });
  media.addEventListener('mouseleave', () => {
    media.querySelector('.product__media-icon--hover').click();
  });
});
}

//shopify dawn theme product media hover script End


